export class ChatSlaConf {
  public sla: boolean;
  public slaDuration: number;
  public slaReminder: number;

  constructor(sla: boolean, slaDuration: number, slaReminder: number) {
    this.sla = sla;
    this.slaDuration = slaDuration;
    this.slaReminder = slaReminder;
  }

  static compare(value1: ChatSlaConf, value2: ChatSlaConf): number {
    if (value1.slaDuration < value2.slaDuration) {
      return -1;
    }
    if (value1.slaDuration > value2.slaDuration) {
      return 1;
    }
    if (value1.slaReminder > value2.slaReminder) {
      return -1;
    }
    if (value1.slaReminder < value2.slaReminder) {
      return 1;
    }
    return 0;
  }
}
